import { ReactNode, useCallback, useMemo, useState } from "react";
import { FormContainer } from "./components/FormContainer";
import { Col, Form, FormInstance, Modal, Row } from "antd";
import { MODAL_MASK_COLOR } from "../../../../../../../../lib/constants";
import { FormButtons } from "./components/FormButtons";
import { ErrorContainer } from "./components/ErrorContainer";
import { IPrimaryData } from "../../types/PrimaryData";
import { useOnFail } from "./hooks/useOnFail";
import { useSend } from "./hooks/useSend";
import "./styles.scss";

type EmailsModalProps = {
  contractId: string;
  isOpen: boolean;
  primaryData: IPrimaryData;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const EmailsModal = ({
  contractId,
  isOpen,
  primaryData,
  setIsOpen,
}: EmailsModalProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [sendToData, setSendToData] = useState<any[]>([]);

  const [form]: FormInstance[] = Form.useForm();

  const [error, setError] = useState<any | null>(null);

  const clearError = useCallback(() => setError(null), []);

  const close = useCallback(() => {
    if (!isLoading) {
      setIsOpen(false);
      form.resetFields();
      clearError();
    }
  }, [isLoading, setIsOpen, form, clearError]);

  const { onFail } = useOnFail(setError);

  const { send } = useSend(
    form,
    contractId,
    sendToData,
    setIsLoading,
    close,
    onFail,
  );

  const title: ReactNode = useMemo(
    () => (
      <Row justify="start" key="modal-title">
        <Col>
          <div className="text w-500">Send Emails</div>
        </Col>
      </Row>
    ),
    [],
  );

  return (
    <Modal
      title={title}
      open={isOpen}
      onCancel={close}
      footer={
        <FormButtons
          form={form}
          isLoading={isLoading}
          close={close}
          send={send}
        />
      }
      width={700}
      centered
      className="bordered-modal emails-modal"
      maskStyle={{ backgroundColor: MODAL_MASK_COLOR }}
      wrapClassName="z-1000 position-fixed"
    >
      {error && <ErrorContainer error={error} />}

      <FormContainer
        contractId={contractId}
        form={form}
        primaryData={primaryData}
        sendToData={sendToData}
        setSendToData={setSendToData}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        clearError={clearError}
      />
    </Modal>
  );
};
